<main [attr.aria-label]="titleDefault" role="main">
  <div [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet" (deactivate)="onDeactivate()"></router-outlet>
  </div>
</main>
